import {OptionTypeBase} from 'platform/components';

import i18n from '@dms/i18n';

export const getSearchTypeOptions = (
  disableMinimumLengthTypes?: boolean
): OptionTypeBase<string>[] => [
  {
    value: 'EQUALS',
    label: i18n.t('entity.warehouse.labels.equals'),
  },
  {
    value: 'LIKE',
    label: i18n.t('entity.warehouse.labels.contains'),
    isDisabled: disableMinimumLengthTypes,
  },
  {
    value: 'STARTS_WITH',
    label: i18n.t('entity.warehouse.labels.startsWith'),
    isDisabled: disableMinimumLengthTypes,
  },
  {
    value: 'ENDS_WITH',
    label: i18n.t('entity.warehouse.labels.endsWith'),
    isDisabled: disableMinimumLengthTypes,
  },
];
